module.exports = __webpack_public_path__ + "assets/img/section-4-landing-kid-right.755ae796.png";